<template>
  <div class="alert">
    <loading message="Loading your notifications" :loading="isLoading">
      <div v-if="page">
        <!-- Policy Description -->
        <h2><i :class="`fas fa-${page.PolicyDetails[0].icon}`"></i> {{ page.PolicyDetails[0].summary }}</h2>
        <p>{{ page.PolicyDetails[0].long_description }}</p>
        <ul>
          <li>Default Risk Score: <b>{{ page.PolicyDetails[0].risk_score }}</b></li>
          <li>Status: <b>{{ page.PolicyDetails[0].policy_status }}</b></li>
        </ul>

        <!-- Pages results -->
        <alert-policy-table :notifications="page.PagedOpenPolicies"/>
        <pager :count="page.PagedOpenPoliciesCount[0].count" :offset="pagingOffset" :size="pagingLimit" @change="changePage"/>

        <b-row>
          <b-col>
            <h2>Scanner results trend</h2>
            <b-table striped 
              :items="page.HistoryTrend" 
              :fields="['ordinal', 'notificationcount']"
              tbody-class="text-right" 
              thead-class="text-right">
              <template #head(ordinal)>
                Scan date
              </template>
              <template #head(notificationcount)>
                Change in notifications
              </template>
              <template #cell(ordinal)="data">
                {{ data.value | moment('DD/MM/YYYY') }}
              </template>
              <template #cell(notificationcount)="data">
                {{ data.value | prefix(data.value > 0 ? '+' : '') }}
              </template>
            </b-table>
          </b-col>
          <b-col>
            <h2>Currently under investigation</h2>
            <alert-policy-table :notifications="page.UnderInvestigation"/>
          </b-col>
        </b-row>
      </div>
    </loading>
  </div>
</template>

<script>
import AlertPolicyTable from '../components/AlertPolicyTable.vue'
import Pager from '../components/Pager.vue'
import Loading from '../components/Loading.vue'

export default {
  components: { AlertPolicyTable, Pager, Loading },
  data() {
    return {
      isLoading: true,
      page: null,
      pagingOffset: 0,
      pagingLimit: 10,
      alertCategory: this.$route.params.alert_category,
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    changePage(number) {
      this.pagingOffset = this.pagingLimit * (number-1);
      this.fetchData();
    },
    fetchData() {
      this.isLoading = true;
      const { access_token } = this.$store.state.oidcStore;
      this.$reportingApi.renderPage('panessex', access_token, {
        pageName: 'Alert',
        parameters: {
          policycodein: this.alertCategory,
          limitin: this.pagingLimit,
          offsetin: this.pagingOffset,
        },
      })
      .then(page => { this.page = page; this.isLoading = false; })
      .catch(e => { this.error = e.message; this.isLoading = false; });
    },
  },
};
</script>
